import React from "react";
import { Link } from "react-router-dom";
import { Button, ListItem, ListItemText } from "@mui/material";
import { useAppSelector } from "@store/hooks";
import { ApplicationPaths } from "../../../../../services/authorizationService/ApiAuthorizationConstants";

const AuthenticatedView: React.FC = () => {
    const profilePath = `${ApplicationPaths.Profile}`;
    const bookingId = useAppSelector(({ ui }) => ui.BookingId);
    const logoutPath = React.useMemo(() => ({ pathname: `${ApplicationPaths.LogOut}`, state: { local: true } }), []);

    return (
        <>
            {!bookingId && (
                <ListItem disablePadding>
                    <Button component={Link} to={profilePath} sx={{ color: "white", textTransform: "uppercase" }} variant="contained" size="small">
                        <ListItemText primary="Account" />
                    </Button>
                </ListItem>
            )}
            {!bookingId && (
                <ListItem disablePadding>
                    <Button component={Link} to={logoutPath.pathname} sx={{ color: "white", textTransform: "uppercase" }} variant="contained" color="error" size="small">
                        <ListItemText primary="Logout" />
                    </Button>
                </ListItem>
            )}
        </>
    );
};

export default React.memo(AuthenticatedView);
